export const URL = {
  homePage: "/",
  createTravelExpense: "/createTravelExpense",
  editTravelExpense: "/editTravelExpense",
  getTravelExpense: "/getTravelExpense",
  userRole: "/userRole",
  reports: "/reports"
};
